import { isConnectAppUserMessage } from '@/utils/connectAppAssistantPayload'
import { isCreateAgentQuestionPrompt } from '../agentQuestion/isCreateAgentQuestionPrompt.js'
import { isGeneratedArtifactUserMessage } from '@/utils/generatedArtifactAssistantPayload'
import { createAssistantStreamSession } from '../streamSession'
import { runApiCompletionStream } from './runApiCompletionStream.js'
import { runAgentQuestionTurn } from './runAgentQuestionTurn.js'
import { runConnectAppTurn } from './runConnectAppTurn.js'
import { runGeneratedArtifactTurn } from './runGeneratedArtifactTurn.js'
import { runResponseComponentDemoStream } from './runResponseComponentDemoStream.js'

/**
 * Shared pipeline after user + pending assistant rows exist (main chat + AI rail).
 * Timers/intervals are tied to `signal` via {@link createAssistantStreamSession}.
 *
 * @param {{
 *   tid: string,
 *   pendingId: string,
 *   trimmed: string,
 *   apiMessages: Array<{ role: string, content: string }>,
 *   files?: unknown[],
 *   mode?: string,
 *   signal: AbortSignal,
 *   setMessagesByThreadId: (updater: (prev: Record<string, unknown[]>) => Record<string, unknown[]>) => void,
 *   allowResponseComponentDemo?: boolean,
 * }} p
 */
export function runInitialAssistantTurn(p) {
  const {
    tid,
    pendingId,
    trimmed,
    apiMessages,
    files,
    mode,
    signal,
    setMessagesByThreadId,
    allowResponseComponentDemo = true,
  } = p

  const session = createAssistantStreamSession(signal)
  const ctx = { tid, pendingId, trimmed, signal, session, setMessagesByThreadId }

  if (allowResponseComponentDemo && trimmed.toLowerCase() === 'response component') {
    runResponseComponentDemoStream(ctx)
    return
  }
  if (isCreateAgentQuestionPrompt(trimmed)) {
    runAgentQuestionTurn(ctx)
    return
  }
  if (isGeneratedArtifactUserMessage(trimmed)) {
    runGeneratedArtifactTurn(ctx)
    return
  }
  if (isConnectAppUserMessage(trimmed)) {
    runConnectAppTurn({ ...ctx, connectContext: p.connectContext })
    return
  }
  runApiCompletionStream({ ...ctx, apiMessages, files, mode })
}
